import {
  useAddFreeTrialCreditMutation,
  useFreeTrialEligibilityRulesQuery,
} from '@trello/graphql/generated';
import { useState } from 'react';
import { Feature } from 'app/scripts/debug/constants';
import { logError } from 'app/scripts/debug/log-error';
const ModelLoader = require('app/scripts/db/model-loader.coffee');

interface UseFreeTrial {
  (args: { orgId: string; onFreeTrial?: () => void }): {
    startFreeTrial: () => void;
    isLoading: boolean;
  };
}

export const useFreeTrial: UseFreeTrial = ({ orgId, onFreeTrial }) => {
  const [isLoading, setLoading] = useState(false);
  const [addFreeTrialCredit] = useAddFreeTrialCreditMutation();
  const { refetch } = useFreeTrialEligibilityRulesQuery({
    variables: {
      orgId,
    },
  });

  const onStartFreeTrial = async () => {
    try {
      setLoading(true);
      await addFreeTrialCredit({
        variables: {
          orgId,
        },
      });

      if (onFreeTrial) {
        onFreeTrial();
      }

      await refetch();

      // We need a way to update to coffeescript views
      ModelLoader.loadOrganizationData(orgId);
    } catch (err) {
      logError({
        error: err,
        tags: {
          ownershipArea: 'trello-bizteam',
          feature: Feature.FreeTrialExistingTeam,
        },
      });
      setLoading(false);
    }
  };

  return {
    startFreeTrial: onStartFreeTrial,
    isLoading,
  };
};
